module.exports = __webpack_public_path__ + "static/media/happy.cc1c78d3.png";